import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { fetchClusterDashboard } from 'api/apartment'
import { Loading } from 'app/components/generic/LottieComponents'
import { formatAmount } from 'app/utils'

import ApartmentPageHeader from '../shared/ApartmentPageHeader'
import MonthFilter from '../shared/MonthFilter'

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3), minWidth: 0, overflowX: 'hidden' },
  metricCard: { padding: theme.spacing(2.5) },
  metricValue: { fontWeight: 600, marginTop: theme.spacing(0.5) },
  sectionTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1.5),
    fontWeight: 600
  }
}))

const ApartmentClusterDashboard = () => {
  const classes = useStyles()
  const [data, setData] = React.useState(null)
  // '' = all time. Expected/Collected/Outstanding narrow to the chosen month.
  const [month, setMonth] = React.useState('')

  React.useEffect(() => {
    let active = true
    setData(null)
    fetchClusterDashboard('', month)
      .then((res) => active && setData(res))
      .catch(
        () =>
          active && setData({ alerts: {}, revenueByComplex: [], growth: [] })
      )
    return () => {
      active = false
    }
  }, [month])

  if (!data) return <Loading />

  return (
    <div className={classes.root}>
      <ApartmentPageHeader
        title="Cluster Head Dashboard"
        showSelector={false}
        subtitle="All complexes"
        action={<MonthFilter value={month} onChange={setMonth} allowAll />}
      />

      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <Paper variant="outlined" className={classes.metricCard}>
            <Typography variant="body2" color="textSecondary">
              Open incidents
            </Typography>
            <Typography variant="h4" className={classes.metricValue}>
              {data.alerts.openIncidents || 0}
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Typography variant="h6" className={classes.sectionTitle}>
        Revenue by complex
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Complex</TableCell>
              <TableCell align="right">Expected</TableCell>
              <TableCell align="right">Collected</TableCell>
              <TableCell align="right">Outstanding</TableCell>
              <TableCell align="right">Collection %</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.revenueByComplex.map((r) => (
              <TableRow key={r.slug}>
                <TableCell>{r.apartment}</TableCell>
                <TableCell align="right">{formatAmount(r.expected)}</TableCell>
                <TableCell align="right">{formatAmount(r.collected)}</TableCell>
                <TableCell align="right">
                  {formatAmount(r.outstanding)}
                </TableCell>
                <TableCell align="right">
                  {r.collectionRate == null ? '—' : `${r.collectionRate}%`}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h6" className={classes.sectionTitle}>
        Growth scorecard
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Complex</TableCell>
              <TableCell align="right">Active enrolments</TableCell>
              <TableCell align="right">Trials</TableCell>
              <TableCell align="right">Trial conversion</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.growth.map((g) => (
              <TableRow key={g.apartment}>
                <TableCell>{g.apartment}</TableCell>
                <TableCell align="right">{g.activeEnrolments}</TableCell>
                <TableCell align="right">{g.trials}</TableCell>
                <TableCell align="right">
                  {g.trialConversionRate == null
                    ? '—'
                    : `${g.trialConversionRate}%`}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default ApartmentClusterDashboard
